import { render, staticRenderFns } from "./editWorkType.vue?vue&type=template&id=b67ea64c&"
import script from "./editWorkType.vue?vue&type=script&lang=js&"
export * from "./editWorkType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports